import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Timezone';
const ENDPOINT = `/timezones/`;

@Injectable({
    providedIn: 'root'
})
export class TimezoneService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
